import { Card, CardContent, CardHeader, Divider, FormControl, FormControlLabel, FormLabel, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Typography } from "@mui/material";
import { TextField, Grid } from "@mui/material";
import { Colors } from "../../../styles/theme";
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';
import { usePreferences } from "hooks/usePreferences";
import { PhoneInputMask } from "../../common/phoneNumberField";

export default function GeneralInfoCard({ formik }) {
    // Get business preferences from the context (pre-loaded, no delay)
    const { preferences: businessPreferences } = usePreferences();

    // Get phone format from preferences or fallback to default
    const phoneFormat = businessPreferences?.phoneNumberFormat || '(###) ###-####';

  const handlePhone = (event, type) => {
    formik.setFieldValue(type, new AsYouType('US').input(event.target.value));
  }

  return (
    <Card elevation={1}>
      <CardHeader title="General" sx={{ color: Colors.muted }} />
      <Divider />
      <CardContent>
        <Grid container columnSpacing={1}>
          <Grid item xs={12} md={4}>
            <TextField
              required
              name="firstName"
              id="firstName"
              onChange={formik.handleChange}
              value={formik.values.firstName}
              error={formik.touched.firstName && formik.errors.firstName}
              helperText={formik.touched.firstName && formik.errors.firstName}
              label="First name"
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              name="middleName"
              value={formik.values.middleName}
              onChange={formik.handleChange}
              id="pr-middle-name"
              label="Middle name"
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              required
              name="lastName"
              id="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && formik.errors.lastName}
              helperText={formik.touched.lastName && formik.errors.lastName}
              label="Last name"
              variant="standard"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={1} alignItems="center" mt={4}>
          <Grid item xs={12} md={4}>
            
            <TextField
              required
              name="mobile"
              value={formik.values.mobile}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: <InputAdornment position="start">{businessPreferences?.countryCode || '+1'}</InputAdornment>,
                inputComponent: PhoneInputMask,
                inputProps: {
                  mask: phoneFormat,
                },
              }}
              error={
                formik.touched.mobile &&
                !isValidPhoneNumber(formik.values.mobile, "US")
              }
              helperText={
                !isValidPhoneNumber(formik.values.mobile, "US") &&
                "Invalid phone"
              }
              id="mobile"
              label="Mobile"
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              name="home"
              value={formik.values.home}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: <InputAdornment position="start">{businessPreferences?.countryCode || '+1'}</InputAdornment>,
                inputComponent: PhoneInputMask,
                inputProps: {
                  mask: phoneFormat,
                },
              }}
              id="pr-home"
              label="Home"
              variant="standard"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              name="work"
              value={formik.values.work}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: <InputAdornment position="start">{businessPreferences?.countryCode || '+1'}</InputAdornment>,
                inputComponent: PhoneInputMask,
                inputProps: {
                  mask: phoneFormat,
                },
              }}
              id="pr-work"
              label="Work"
              variant="standard"
              fullWidth
            />
          </Grid>
        </Grid>
        <FormControl sx={{ mt: 4 }}>
          <FormLabel id="sex" sx={{ display: 'flex' }}>Gender</FormLabel>
          <RadioGroup
            name="sex"
            error={
              formik.touched.sex && Boolean(formik.errors.sex)
            }
            value={formik.values.sex}
            onChange={formik.handleChange}
            row
          >
            <FormControlLabel
              value="female"
              control={<Radio size="small" />}
              label="Female"
            />
            <FormControlLabel
              value="male"
              control={<Radio size="small" />}
              label="Male"
            />
            <FormControlLabel
              value="other"
              control={<Radio size="small" />}
              label="Other"
            />
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
}